import styles from "./Presentation.module.css";
import React, {Fragment, useEffect, useState} from "react";
import {
    BLANK_REGEX,
    BLANK_REGEX_NEW,
    BLANK_REGEX_WRAPPED,
    BLANK_REGEX_WRAPPED_NEW,
    QUESTION_TYPES, RELEASE_ACTIVITY_VIEW,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import {isGeneralSA, questionCodeToName} from "../../utils/questionUtils";
import {LatexInline} from "../../components/Tiptap/latexParser";
import ImageViewer from "../JoinQuizPage/ImageViewer";
import classes from "../ReleaseActivityPage/ReleaseActivityPage.module.css";
import ViewLiveRespCountChart from "../ReleaseActivityPage/ViewLiveRespCountChart";
import {
    delay, getQuestionCorrectnessPoints, getQuestionParticipationPoints,
    getQuestionWeightage,
    isManualGradeQue, questionHasCorrectness,
    questionHasWeightage,
    removePrefixNew,
    getSafeURL
} from "../../utils/helpers";
import responseClasses from "../JoinQuizPage/ClassResult.module.css";
import { ReactComponent as NoResultIllustration } from "../../images/notGradedAttendance.svg";
import WordCloudResult from "../JoinQuizPage/WordCloudResult";
import ViewLiveRespRK from "../ReleaseActivityPage/ViewLiveRespRK";
import ViewLiveRespMH from "../ReleaseActivityPage/ViewLiveRespMH";
import ViewLiveRespOE from "../ReleaseActivityPage/ViewLiveRespOE";
import YuJaButton from "../../components/standardization/YuJaButton";
import EndPollModal from "../../components/modals/EndPollModal";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import parse from "html-react-parser";
import YuJaSwitch from "../../components/standardization/YuJaSwitch";
import {Accordion} from "@base-ui/react/accordion";

export default function ViewPresentQuestion({pollData, question, reactionCountData, responseCountData, localState, resetPollData}) {
    const { t } = useTranslation();
    const {poll={}} = pollData;
    const {pk, sk} = poll;
    let pollKey = removePrefixNew(pk);
    let pollCode = removePrefixNew(sk);
    const {serialNo, shareCount=0} = question;
    const liveResponses = responseCountData[serialNo - 1];
    const reactionData = !!reactionCountData[serialNo - 1]
        ? reactionCountData[serialNo - 1]
        : {thumbUp: 0, thumbDown: 0};
    const SHARE_STATUS_ENUM = {UNSHARED: "UNSHARED", SHARING: "SHARING", SHARED: "SHARED"};


    const { shareQuestion,  stopQuestion,} = PollApiCalls();
    // const {createGradeColumn} = LTIApiCalls();

    const [shareStatus, setShareStatus] = useState(SHARE_STATUS_ENUM.UNSHARED);
    const [showAnswer, setShowAnswer] = useState(false);
    const [isShareQuestionProcessing, setIsShareQuestionProcessing] = useState(false);
    const [endPollModalShow, setEndPollModalShow] = useState(false);

    let isQuestionSharing = localState === "GET_READY" || localState === "SHARED";



    useEffect(() => {
        if ((localState === "GET_READY" || localState === "SHARED") && poll.liveQuestionNo === serialNo) {
            setShareStatus(SHARE_STATUS_ENUM.SHARING);
        } else if (!!shareCount) {
            setShareStatus(SHARE_STATUS_ENUM.SHARED);
        } else {
            setShareStatus(SHARE_STATUS_ENUM.UNSHARED);
        }
    }, [shareCount, localState]);

    const handleStop = async (isEndPoll=false) => {
        await stopQuestion(pollKey, pollCode, serialNo, poll.pollType, isEndPoll);
        resetPollData();
    };

    const handleShare = async () => {
        try {
            setIsShareQuestionProcessing(true);
            await delay(3000)
            await shareQuestion(pollKey, pollCode, serialNo, poll.pollType);
            // createGradeColumn(pollKey, pollCode);
            resetPollData(RELEASE_ACTIVITY_VIEW.RELEASE_VIEW);
        } finally {
            setIsShareQuestionProcessing(false);
        }

        // let quesTimeLimit = pollData.questions[currentQuestionNo-1].timeLimit;
        // setQueEnd(res.liveQuestionTime + parseInt(getTimeOffset()) + quesTimeLimit * 1000);
        // setSharedQuestionNo(currentQuestionNo);
        // setLocalState('GET_READY');
        // countDownRef.current.start();
    };


    const renderAllCorrectOptions = (blankName) => {
        if (!question.correctAnswers.hasOwnProperty(blankName) || !question.correctAnswers[blankName].length) {
            return "";
        }


        if (question.correctAnswers[blankName].length === 1) {
            return question.correctAnswers[blankName];
        }

        let allOpts = "";
        for(let element of question.correctAnswers[blankName]) {
            if(allOpts !== "") {
                allOpts += " / " + element;
            }
            else {
                allOpts += element;
            }
        }
        return allOpts;
    };

    const renderTitle = () => {


        if (question.questionType !== QUESTION_TYPES.FITB.name) {
            return <span><LatexInline>{question.queTitle}</LatexInline></span>;
        }
        return (
            <span className={styles.row} style={{flexWrap: "wrap"}}>
               {question.queTitle.split(question.hasBlankRestriction ? BLANK_REGEX_WRAPPED_NEW : BLANK_REGEX_WRAPPED).map((str, i) => { // /(\(.*?\))/g
                   let re = new RegExp(question.hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX); // /\([^\(\)]+\)/g
                   if (!re.test(str)) {
                       const oneLine = str.replace(/[\r\n]/g, " @newLine ");
                       const wordArr = oneLine ? oneLine.split(" ") : [];
                       return (
                           <Fragment key={i}>
                               {wordArr.map((s, idx) => (
                                   <Fragment key={idx}>
                                       {s === '@newLine' &&
                                           <div style={{width: "100%"}}></div>
                                       }
                                       {!!s && s !== '@newLine' &&
                                           <div style={{marginRight: "5px"}}>{s}</div>
                                       }
                                   </Fragment>
                               ))}
                           </Fragment>
                       );
                   } else {
                       let blankName = str.substring(1, str.length - 1);

                       return (
                           <div className={`${styles.FITBBox} ${showAnswer ? styles.correct : ""}`}>
                               {!!showAnswer &&
                                   renderAllCorrectOptions(blankName)
                               }
                           </div>
                       );
                   }
               })}
           </span>
        );

    }


    return (
        <div className={`${styles.rightPart} ${styles.column}`} style={{gap: 15}}>
            <EndPollModal
                show={endPollModalShow}
                setModalShow={setEndPollModalShow}
                localState={localState}
                poll={poll}
                handleStop={handleStop}
                handleStopAll={() => {
                }}
            />

            <div className={styles.row} style={{gap: 15}}>
                <span style={{fontSize: 18, fontWeight: "500", lineHeight: "22px"}}>
                    {t('poll.questionLabelWithSpace')} {question.serialNo}
                </span>

                {questionHasWeightage(question) &&
                    <YuJaTooltip
                        disableTab={true}
                        disabled={!getQuestionParticipationPoints(question)}
                        text={parse(
                            `<span>
                                            ${getQuestionCorrectnessPoints(question)} Correctness Points</br> 
                                            ${getQuestionParticipationPoints(question)} Participation Points</span>`
                        )}
                    >
                        <span
                            className={styles.badge}
                            style={{width: "fit-content", padding: "0 10px", backgroundColor: "#E4E3F6"}}
                        >
                            {getQuestionWeightage(question)} {t('poll.pointsText')}
                        </span>
                    </YuJaTooltip>

                }

                <div className={styles.row} style={{flex: 1}}>
                    <span className={`${classes.thumbUpIcon} ${classes.nonHover} `} style={{marginRight: 3}}/>
                    <span style={{
                        fontSize: 15,
                        fontWeight: 500,
                        color: "#4D4D4D"
                    }}> {reactionData["thumbUp"]} </span>
                    <div style={{width: 7}}/>
                    <span className={`${classes.thumbDownIcon} ${classes.nonHover}`} style={{marginRight: 3}}/>
                    <div style={{
                        fontSize: 15,
                        fontWeight: 500,
                        color: "#4D4D4D"
                    }}> {reactionData["thumbDown"]} </div>
                </div>

                <div className={styles.row} style={{gap: 15}}>
                    {!poll.pollEnded &&
                        <YuJaButton
                            type={"delete"}
                            style={{width: 150, height: 40}}
                            onClick={() => setEndPollModalShow(true)}
                        >
                            {t('common.finish')}
                        </YuJaButton>
                    }

                    <YuJaTooltip
                        disabled={!isQuestionSharing}
                        placement={"bottom"}
                        text={poll.liveQuestionNo === question.serialNo
                            ? t("poll.cannotReleaseQuestionDuringSharing")
                            // ? "Finish sharing the question to release this one."
                            : t("poll.finishPreviousQuestionFirst")
                        }
                    >
                        <div
                            tabIndex={0}
                            className={`${styles.releaseBtn} ${(isShareQuestionProcessing || isQuestionSharing) ? styles.disabled : ""}`}
                            style={{width: 150}}
                            onClick={() => {
                                if (!isShareQuestionProcessing && !isQuestionSharing) {
                                    handleShare();
                                }
                            }}
                        >
                            <span className={`${isShareQuestionProcessing ? styles.precessingText : ""}`}>
                                {!!question.shareCount ? t("poll.reReleaseQuestionShort") : t("poll.releaseQuestionShort")}{serialNo}
                            </span>
                        </div>
                    </YuJaTooltip>

                </div>
            </div>


            <div className={styles.row} style={{gap: 20, alignItems: "start"}}>
                <div className={styles.column} style={{gap: 15, flex: 1}}>
                    <div className={styles.row} style={{gap: 15}}>
                        <span style={{color: "#6B6B6B"}}>
                            {questionCodeToName(question.questionType)}
                        </span>


                        <span style={{flex: 1}}/>


                        {questionHasCorrectness(question) && !isManualGradeQue(true, question.questionType) &&
                            <span
                                className={classes.row}
                                style={{gap: 5}}
                                onClick={e => {
                                    e.stopPropagation();
                                    setShowAnswer(!showAnswer);
                                }}
                            >
                                <span>{t("questionBuilder.showCorrectAnswerTitle")}</span>
                                <YuJaSwitch
                                    aria-label={t("questionBuilder.showCorrectAnswerTitle")}
                                    checked={showAnswer}
                                    onChange={checked => setShowAnswer(checked)}
                                />
                            </span>

                        }
                    </div>
                    {renderTitle()}
                </div>


            </div>

            <div style={{height: 20}}/>

            {!!question.imageURL && !question.directLinkEvp &&
                <ImageViewer
                    width={360}
                    height={170}
                    alt={question.imageAlt}
                    imageURL={question.imageURL}
                    styles={{alignSelf: "center"}}
                />
            }
            {!question.imageURL && !!getSafeURL(question.directLinkEvp) &&
                <iframe allowFullScreen style={{width: 360, height: 240, alignSelf: "center"}}
                        src={getSafeURL(question.directLinkEvp)}/>
            }


            <div className={styles.column} style={{position: "relative", gap: 15}}>
                {(shareStatus === SHARE_STATUS_ENUM.SHARING || shareStatus === SHARE_STATUS_ENUM.SHARED) &&
                    <span
                        style={{
                            fontSize: 18,
                            fontWeight: "500",
                            width: "fit-content",
                            position: question.questionType === QUESTION_TYPES.OE.name ? "absolute" : "unset"
                        }}
                    >{t('poll.allResponsesText')}</span>
                }

                {!!liveResponses && (question.questionType === QUESTION_TYPES.MCSS.name
                        || question.questionType === QUESTION_TYPES.TF.name
                        || question.questionType === QUESTION_TYPES.CI.name)
                    &&
                    <ViewLiveRespCountChart
                        chartData={liveResponses}
                        showCorrectAnswer={showAnswer}
                        question={question}
                        isExpanded={true}
                        isShared={shareStatus === SHARE_STATUS_ENUM.SHARING || shareStatus === SHARE_STATUS_ENUM.SHARED}
                    />
                }

                {!!liveResponses
                    && isGeneralSA(question.questionType)
                    && (shareStatus === SHARE_STATUS_ENUM.SHARING || shareStatus === SHARE_STATUS_ENUM.SHARED)
                    &&
                    <div className={classes.column} style={{gap: 10}}>
                        {!!liveResponses && liveResponses.length > 0 && liveResponses.map((response, index) =>
                            <div key={index} className={responseClasses.allResponseCard}>
                                {response}
                            </div>
                        )}

                        {(!liveResponses || !liveResponses.length) &&
                            <>
                                <NoResultIllustration width={130} height={71}
                                                      style={{alignSelf: "center", marginTop: 20}}/>
                                <span style={{fontSize: 16, lineHeight: "19px", fontWeight: 600, alignSelf: "center"}}>
                                    {t('response.noResponsesYet')}
                                </span>
                                <span style={{fontSize: 14, lineHeight: "16px", fontWeight: 400, alignSelf: "center"}}>
                                    {t('poll.saNoResponseExplainReleasePage')}
                                </span>
                            </>
                        }
                    </div>
                }

                {!!liveResponses
                    && question.questionType === QUESTION_TYPES.FITB.name
                    && (shareStatus === SHARE_STATUS_ENUM.SHARING || shareStatus === SHARE_STATUS_ENUM.SHARED)
                    &&
                    <div className={styles.column} style={{gap: 10}}>
                        {liveResponses.map((response, index) =>
                            <div key={index} className={responseClasses.allResponseCard}>
                                <div>
                                    {Object.keys(response).map((key, idx) =>
                                        <div key={idx}>- {response[key]}</div>
                                    )}
                                </div>
                            </div>
                        )}

                        {(!liveResponses || !liveResponses.length) &&
                            <>
                                <NoResultIllustration width={130} height={71}
                                                      style={{alignSelf: "center", marginTop: 20}}/>
                                <span style={{fontSize: 16, lineHeight: "19px", fontWeight: 600, alignSelf: "center"}}>
                                        {t('response.noResponsesYet')}
                                    </span>
                                <span style={{fontSize: 14, lineHeight: "16px", fontWeight: 400, alignSelf: "center"}}>
                                      {t('poll.saNoResponseExplainReleasePage')}
                                  </span>
                            </>
                        }
                    </div>
                }

                {!!liveResponses
                    && question.questionType === QUESTION_TYPES.WC.name
                    && (shareStatus === SHARE_STATUS_ENUM.SHARING || shareStatus === SHARE_STATUS_ENUM.SHARED)
                    &&
                    <div
                        style={{
                            alignSelf: "center",
                            width: "min(800px, 100%)",
                            height: 300,
                            backgroundColor: "#F6F6F6E6",
                            border: "1px solid #E6E6E6",
                            borderRadius: 4,
                            display: "flex", alignItems: "center", justifyContent: "center"
                        }}
                    >
                        <WordCloudResult data={liveResponses}/>
                    </div>
                }

                {!!liveResponses && question.questionType === QUESTION_TYPES.RK.name &&
                    <ViewLiveRespRK
                        question={question}
                        chartData={liveResponses}
                        isExpanded={true}
                    />
                }

                {!!liveResponses && question.questionType === QUESTION_TYPES.MH.name &&
                    <Accordion.Root multiple className={classes.column} style={{gap: 10}} >
                        {question.correctAnswers.filter(i => i.length > 1).map((key, index) =>
                            <ViewLiveRespMH
                                key={index}
                                correctAnswers={question.correctAnswers}
                                premise={key[0]}
                                premiseIdx={index}
                                data={liveResponses[key[0]]}
                                shouldShowCorrect={showAnswer}
                                isShared={shareStatus === SHARE_STATUS_ENUM.SHARING || shareStatus === SHARE_STATUS_ENUM.SHARED}
                            />
                        )}
                    </Accordion.Root>
                }

                {!!liveResponses
                    && question.questionType === QUESTION_TYPES.OE.name
                    && (shareStatus === SHARE_STATUS_ENUM.SHARING || shareStatus === SHARE_STATUS_ENUM.SHARED)
                    &&
                    <ViewLiveRespOE originalData={liveResponses}/>
                }
            </div>


            {/*<div className={styles.column}*/}
            {/*     style={{flex: 1, minHeight: 36, justifyContent: "end", alignItems: "end", gap: 5}}>*/}
            {/*    <div className={styles.row} style={{gap: 15, justifyContent: "end"}}>*/}
            {/*        {!poll.pollEnded &&*/}
            {/*            <YuJaButton*/}
            {/*                type={"delete"}*/}
            {/*                style={{width: 150, height: 40}}*/}
            {/*                onClick={() => setEndPollModalShow(true)}*/}
            {/*            >*/}
            {/*                {t('common.finish')}*/}
            {/*            </YuJaButton>*/}
            {/*        }*/}

            {/*        <YuJaTooltip*/}
            {/*            disabled={!isQuestionSharing}*/}
            {/*            text={poll.liveQuestionNo === question.serialNo*/}
            {/*                ? "You are not able to release the question during the sharing."*/}
            {/*                // ? "Finish sharing the question to release this one."*/}
            {/*                : "Finish sharing the previous question to release this one."*/}
            {/*            }*/}
            {/*        >*/}
            {/*            <div*/}
            {/*                tabIndex={0}*/}
            {/*                className={`${styles.releaseBtn} ${(isShareQuestionProcessing || isQuestionSharing) ? styles.disabled : ""}`}*/}
            {/*                style={{width: 150}}*/}
            {/*                onClick={() => {*/}
            {/*                    if (!isShareQuestionProcessing && !isQuestionSharing) {*/}
            {/*                        handleShare();*/}
            {/*                    }*/}
            {/*                }}*/}
            {/*            >*/}
            {/*                <span className={`${isShareQuestionProcessing ? styles.precessingText : ""}`}>*/}
            {/*                    {!!question.shareCount ? "Re-Release Q" : "Release Q"}{serialNo}*/}
            {/*                </span>*/}
            {/*            </div>*/}
            {/*        </YuJaTooltip>*/}

            {/*    </div>*/}
            {/*</div>*/}

        </div>
    );
}